import {takeLatest} from 'redux-saga/effects';
import {fetchTerms, TermsTypes} from 'store/reducers/terms';

const termsSagas = [takeLatest(TermsTypes.FETCH_TERMS_REQUEST, fetchTerms)];

export default termsSagas;
